module.exports = __webpack_public_path__ + "img/pic-paging-aiot-1.a27266e7.jpg";